type Redirect = (route: string) => string | false;

export const loggedInRedirects: Redirect[] = [
  route => ['/login'].includes(route) && '/dispatching',
];

export const loggedOutRedirects: Redirect[] = [
  route => !['/login', '/signup'].includes(route) && '/login',
];
